import { render, staticRenderFns } from "./SettingsSetupChecksList.vue?vue&type=template&id=839fa72a"
import script from "./SettingsSetupChecksList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsSetupChecksList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsSetupChecksList.vue?vue&type=style&index=0&id=839fa72a&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports